<template>
  <div class="print-pdf unit container edit-user-unit-container">
    <div class="pdf-background-img-container">
      <div class="pdf-background-image"></div>
    </div>
    <div class="contentSection">
      <div v-if="isFetching" class="pa-8 text-center">
        <v-progress-circular indeterminate size="28" class="mr-2" />
        Loading week…
      </div>
      <div v-else-if="prevWeek">
        <div class="">
          <div class="close-link" @click="closebuilder">
            <v-icon>arrowleft</v-icon>
            <span class="close-link-text">BACK TO EDIT WEEK</span>
          </div>
        </div>
        <div>
          <div class="unit-meta-container">
            <div class="mb-0 mt-4">
              <h2
                id="unit-title"
                class="base-year"
                v-html="prevWeek.title"
              ></h2>
            </div>
            <div class="mb-7 mt-0">
              <span class="font-weight-bold" v-html="prevWeek.subtitle"></span>
            </div>
          </div>

          <v-flex xs12>
            <div id="mission" class="break-page-after">
              <div class="flex-container">
                <div class="font-weight-bold text-h6 base-year">MISSION</div>
                <v-divider class="dashed" style="margin-top: 15px"></v-divider>
              </div>

              <div
                v-if="prevWeek.missionBodyContent"
                v-html="prevWeek.missionBodyContent"
                class="print-content-container mb-7 mt-3"
              ></div>

              <PreviewStudyQuestions
                :unitbackdoor="unitbackdoor"
                :content="prevWeek.missionStudyQuestions"
                section="missionStudyQuestions"
              />
            </div>

            <div id="supplication" class="break-page-after">
              <div class="flex-container">
                <div class="font-weight-bold text-h6 base-year">
                  SUPPLICATION
                </div>
                <v-divider class="dashed" style="margin-top: 15px"></v-divider>
              </div>

              <UserVersesQuotes
                :content="prevWeek.supplicationVerseQuotes"
                section="supplicationVerseQuotes"
              />

              <v-divider
                v-if="prevWeek.supplicationVerseQuotes"
                class="dashed"
              ></v-divider>

              <div
                v-if="prevWeek.supplicationBodyContent"
                v-html="prevWeek.supplicationBodyContent"
                class="print-content-container mb-7 mt-3"
              ></div>

              <PreviewStudyQuestions
                :unitbackdoor="unitbackdoor"
                :content="prevWeek.supplicationStudyQuestions"
                section="supplicationStudyQuestions"
              />
            </div>
          </v-flex>
        </div>
      </div>
      <div v-else>No Unit to preview.</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import PreviewStudyQuestions from '@/components/utilities/PreviewStudyQuestions'
  import UserVersesQuotes from '@/components/utilities/UserVersesQuotes'
  import { hydratePreviewFromRoute } from '@/helpers/previewBridge'

  export default {
    name: 'PreviewWeek',
    components: {
      PreviewStudyQuestions,
      UserVersesQuotes,
    },
    data() {
      return {
        feedback: null,
        unit: [],
        currentCourse: [],
        unitbackdoor: 0,
        backdoor: 0,
        listenConfirmed: null,
        completeConfirmed: null,
        continueConfirmed: null,
        isFetching: false,
        fetchDelay: 500,
      }
    },
    computed: {
      ...mapState('UserData', ['user']),
      ...mapState('AppData', ['userActiveCourse', 'prevWeek']),
      ...mapGetters('AppData', ['getCourse', 'getActiveCourse']),
      ...mapGetters('UserData', ['getRoles']),
    },
    methods: {
      init() {
        this.unitbackdoor++
      },
      closebuilder() {
        window.close()
      },
    },
    async created() {
      this.isFetching = true
      const delay = new Promise((res) => setTimeout(res, this.fetchDelay))
      const load = hydratePreviewFromRoute({
        route: this.$route,
        store: this.$store,
        type: 'week',
      })
      await Promise.all([load, delay])
      this.isFetching = false
      this.init()
    },
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }
  #mission
    :deep(p, )
    #supplication
    :deep(p, )
    #mission
    :deep(img, )
    #supplication
    :deep(img) {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 16px;
    padding-bottom: 12px;
    margin-bottom: 0px;
  }

  .print-content-container,
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .unit.container {
    max-width: 800px;
    margin-left: 10%;
  }
  .unit.container .background-img-container {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .unit.container .pdf-background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(../../assets/mountains_bw.jpg) no-repeat 50% 0;
    background-size: cover;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    /*filter: grayscale(100%) blur(0px);*/
  }
  .v-theme--dark .unit.container .pdf-background-image {
    filter: grayscale(100%) blur(0px) invert(1);
  }
  .pdf-background-image-donotuse:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.85);
  }
  .unit .contentSection {
    /* margin-bottom: 50%; */
    /* max-height: 90vh;
    overflow: hidden; */
    position: relative;
  }
  .edit-user-unit-container.blueYear :deep(a) {
    color: #002b45;
  }
  .edit-user-unit-container.redYear :deep(a) {
    color: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(a) {
    color: #024731;
  }
  .flex-this {
    display: flex;
  }
  .edit-user-unit-container :deep(img) {
    max-width: 100%;
  }
  @media only screen and (max-width: 767px) {
    .flex-this {
      flex-direction: column;
    }
  }
</style>
